
import React, { useEffect } from "react"
import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Badge,
    Button,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Input,
    Label,
    FormGroup,
} from "reactstrap"
import { connect } from "react-redux"

//Import Action
import {
    setBreadcrumbItems,
    getInvoices,
    updateInvoiceStatus
} from "../../../store/actions"

const InvoicesList = (props) => {
    const [avoirModal, setAvoirModal] = React.useState(false);
    const [selectedInvoice, setSelectedInvoice] = React.useState(null);
    const [avoirAmount, setAvoirAmount] = React.useState(0);
    const [avoirNotes, setAvoirNotes] = React.useState("");
    document.title = "Gestion des Factures | CRM Admin";

    const breadcrumbItems = [
        { title: "CRM", link: "#" },
        { title: "Admin", link: "#" },
        { title: "Factures Abonnements", link: "#" },
    ]

    useEffect(() => {
        props.setBreadcrumbItems("Factures Abonnements", breadcrumbItems)
        props.getInvoices()
    }, [])

    const handleUpdateStatus = (invoiceId, status) => {
        if (window.confirm(`Changer le statut de la facture en ${status} ?`)) {
            props.updateInvoiceStatus(invoiceId, status)
        }
    }

    const getStatusBadge = (status) => {
        switch (status) {
            case 'paid':
                return <span className="badge badge-soft-success font-size-12 px-2 py-1">Payée</span>
            case 'sent':
                return <span className="badge badge-soft-info font-size-12 px-2 py-1">Envoyée</span>
            case 'overdue':
                return <span className="badge badge-soft-danger font-size-12 px-2 py-1">En retard</span>
            case 'canceled':
                return <span className="badge badge-soft-secondary font-size-12 px-2 py-1">Annulée</span>
            default:
                return <span className="badge badge-soft-warning font-size-12 px-2 py-1">Brouillon</span>
        }
    }

    const handleDownloadPdf = async (invoiceId) => {
        try {
            const token = localStorage.getItem('authUser')
            const user = token ? JSON.parse(token) : null
            const authToken = user?.token || user?.access_token

            const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/invoices/${invoiceId}/pdf`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${authToken}`,
                    'Accept': 'application/pdf',
                },
            })

            if (!response.ok) {
                throw new Error('Erreur lors du téléchargement')
            }

            const blob = await response.blob()
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.download = `Facture-${invoiceId}.pdf`
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
        } catch (error) {
            console.error('Erreur téléchargement PDF:', error)
            alert('Erreur lors du téléchargement du PDF')
        }
    }

    return (
        <React.Fragment>
            <Row>
                <Col className="col-12">
                    <Card>
                        <CardBody>
                            <CardTitle className="h4 mb-4">Historique des Factures d'Abonnement</CardTitle>

                            <div className="table-responsive">
                                <table className="table table-centered table-nowrap mb-0">
                                    <thead className="table-light">
                                        <tr>
                                            <th>N° Facture</th>
                                            <th>Entreprise</th>
                                            <th>Plan / Période</th>
                                            <th>Montant Total</th>
                                            <th>Statut</th>
                                            <th>Date d'échéance</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(props.invoices || []).map((invoice, key) => (
                                            <tr key={key}>
                                                <td>
                                                    <span className="text-primary fw-bold">{invoice.invoice_number}</span>
                                                    {invoice.type === 'credit_note' && (
                                                        <div className="mt-1">
                                                            <Badge color="danger">AVOIR</Badge>
                                                        </div>
                                                    )}
                                                </td>
                                                <td>
                                                    <div className="font-size-14 mb-1">{invoice.company?.name}</div>
                                                    <div className="text-muted font-size-12">{invoice.company?.email}</div>
                                                </td>
                                                <td>
                                                    <div className="font-size-13">{invoice.subscription?.plan?.name}</div>
                                                    <small className="text-muted">
                                                        {new Date(invoice.period_start).toLocaleDateString()} - {new Date(invoice.period_end).toLocaleDateString()}
                                                    </small>
                                                </td>
                                                <td>
                                                    <div className="fw-bold">{parseFloat(invoice.total_amount).toLocaleString()} MAD</div>
                                                    <small className="text-muted">HT: {parseFloat(invoice.amount).toLocaleString()} MAD</small>
                                                </td>
                                                <td>{getStatusBadge(invoice.status)}</td>
                                                <td>
                                                    {invoice.due_date ? new Date(invoice.due_date).toLocaleDateString() : "-"}
                                                </td>
                                                <td>
                                                    <UncontrolledDropdown>
                                                        <DropdownToggle href="#" className="card-drop" tag="i">
                                                            <Button color="light" size="sm">
                                                                Actions <i className="mdi mdi-chevron-down ms-1"></i>
                                                            </Button>
                                                        </DropdownToggle>
                                                        <DropdownMenu className="dropdown-menu-end">
                                                            <DropdownItem onClick={() => handleUpdateStatus(invoice.id, 'paid')}>
                                                                <i className="mdi mdi-check-circle text-success me-1"></i> Marquer comme payée
                                                            </DropdownItem>
                                                            <DropdownItem onClick={() => handleUpdateStatus(invoice.id, 'overdue')}>
                                                                <i className="mdi mdi-clock-alert text-danger me-1"></i> En retard
                                                            </DropdownItem>
                                                            <DropdownItem onClick={() => handleUpdateStatus(invoice.id, 'canceled')}>
                                                                <i className="mdi mdi-close-circle text-secondary me-1"></i> Annuler
                                                            </DropdownItem>
                                                            <DropdownItem divider />
                                                            <DropdownItem onClick={() => handleDownloadPdf(invoice.id)}>
                                                                <i className="mdi mdi-download me-1"></i> Télécharger PDF
                                                            </DropdownItem>
                                                            {invoice.type !== 'credit_note' && invoice.status !== 'canceled' && (
                                                                <>
                                                                    <DropdownItem divider />
                                                                    <DropdownItem onClick={() => {
                                                                        setSelectedInvoice(invoice);
                                                                        setAvoirAmount(invoice.total_amount);
                                                                        setAvoirNotes(`Avoir pour la facture ${invoice.invoice_number}`);
                                                                        setAvoirModal(true);
                                                                    }}>
                                                                        <i className="mdi mdi-file-undo text-danger me-1"></i> Créer un Avoir
                                                                    </DropdownItem>
                                                                </>
                                                            )}
                                                        </DropdownMenu>
                                                    </UncontrolledDropdown>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                {(!props.invoices || props.invoices.length === 0) && (
                                    <div className="text-center p-4 text-muted">
                                        Aucune facture trouvée.
                                    </div>
                                )}
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            <Modal isOpen={avoirModal} toggle={() => setAvoirModal(!avoirModal)}>
                <ModalHeader toggle={() => setAvoirModal(!avoirModal)}>
                    Créer un Avoir pour {selectedInvoice?.invoice_number}
                </ModalHeader>
                <ModalBody>
                    <FormGroup>
                        <Label>Montant de l'avoir (TTC)</Label>
                        <Input
                            type="number"
                            step="0.01"
                            max={selectedInvoice?.total_amount}
                            value={avoirAmount}
                            onChange={(e) => setAvoirAmount(e.target.value)}
                        />
                        <small className="text-muted">Maximum: {selectedInvoice?.total_amount} MAD</small>
                    </FormGroup>
                    <FormGroup>
                        <Label>Note / Raison</Label>
                        <Input
                            type="textarea"
                            rows="3"
                            value={avoirNotes}
                            onChange={(e) => setAvoirNotes(e.target.value)}
                        />
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setAvoirModal(false)}>Annuler</Button>
                    <Button color="danger" onClick={() => {
                        if (!avoirAmount || avoirAmount <= 0) {
                            alert("Veuillez saisir un montant valide.");
                            return;
                        }
                        if (avoirAmount > selectedInvoice.total_amount) {
                            alert("Le montant de l'avoir ne peut pas dépasser le montant de la facture.");
                            return;
                        }

                        import("../../../helpers/fakebackend_helper").then(helper => {
                            helper.addAdminCreditNote(selectedInvoice.id, {
                                amount: avoirAmount,
                                notes: avoirNotes
                            }).then(() => {
                                alert("Avoir créé avec succès.");
                                setAvoirModal(false);
                                props.getInvoices();
                            }).catch(err => {
                                alert("Erreur lors de la création de l'avoir.");
                            });
                        });
                    }}>Générer l'Avoir</Button>
                </ModalFooter>
            </Modal>
        </React.Fragment>
    )
}

const mapStateToProps = state => {
    return {
        invoices: state.InvoicesAdmin.invoices,
        meta: state.InvoicesAdmin.meta,
    }
}

export default connect(mapStateToProps, {
    setBreadcrumbItems,
    getInvoices,
    updateInvoiceStatus
})(InvoicesList)
